import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=8cff1860&scoped=true&"
import script from "./Confirmation.js?vue&type=script&lang=js&"
export * from "./Confirmation.js?vue&type=script&lang=js&"
import style0 from "./Confirmation.scss?vue&type=style&index=0&id=8cff1860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cff1860",
  null
  
)

export default component.exports